const API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://api.olympus.nyc'
  : '';

export const fetchJson = async (endpoint) => {
  const response = await fetch(`${API_BASE}${endpoint}`);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const API_KEY = 'd09a4781-772f-48f1-8094-0e83073e34f5';
